module.exports = __webpack_public_path__ + "static/img/01.8aefeec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/01.jpg
// module id = vD+y
// module chunks = 0